export const signInUsernameState = {
  path: 'step-1',
  title: 'Sign in | Learn My Way'
}

export const signInPasswordState = {
  path: 'step-2',
  title: 'Sign in | Learn My Way'
}

export const signInForgottenPasswordState = {
  path: 'step-3',
  title: 'Forgotten password | Learn My Way'
}

export const signInLazyLoaded = {
  path: 'sign-in'
}
